import { type ApiGroup } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const groupColumns: Column<ApiGroup>[] = [{ name: 'label', label: 'Name' }];
